// extracted by mini-css-extract-plugin
export var cartItem = "_t-3";
export var drawerContent = "_t-0";
export var emptyCart = "_t-2";
export var fadeIn = "_t-4";
export var imagePlaceholder = "_t-6";
export var itemImage = "_t-5";
export var itemsContainer = "_t-1";